import Box from "@mui/material/Box"
import VehiclesLeadModelTable from "./VehiclesLeadModelTable/VehiclesLeadModelTable"
import VehiclesLeadModelFilter from "./VehiclesLeadModelFilter/VehiclesLeadModelFilter"

function VehiclesLeadModel() {
    return (
        <>
            <Box px={2} pt={2}>
                <VehiclesLeadModelFilter/>
            </Box>
            <Box px={2} pt={2}>
                <VehiclesLeadModelTable/>
            </Box>
        </>
    )
}

export default VehiclesLeadModel
